import { Alert } from 'foundations-components/transitional/components/Alert';
import { useIsSensitiveDataEnabled } from '../hooks/useSensitiveDataSettings';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const SensitiveDataEditorBanner = ({
  bannerText,
  onClose
}) => {
  const {
    loading,
    data
  } = useIsSensitiveDataEnabled();
  if (loading || !(data !== null && data !== void 0 && data.sensitiveDataEnabled)) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    "data-test-id": "sensitive-data-banner",
    paddingBlockEnd: "300",
    paddingInline: "300",
    backgroundColor: "fill-field-default",
    children: /*#__PURE__*/_jsx(Alert, {
      type: "warning",
      onClose: () => {
        onClose();
      },
      closeable: true,
      children: bannerText
    })
  });
};
SensitiveDataEditorBanner.displayName = 'SensitiveDataEditorBanner';